module.exports = __webpack_public_path__ + "img/icon_sns_03.e96e26f8.svg";